import { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import AudioButton from "../../../Components/Media/AudioButton";
import { Grid, Box, Typography } from "@mui/material";
import SmartCheckCard from "../../../Components/Card/AssetUI/SmartCheckCard";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

const RecadvAsset = (props) => {
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  useEffect(() => {
    console.log("HERERE");
    if (props.userAns) {
      setCurrentIndexPlay(new Array(props.userAns?.ans?.length).fill(false));
    }
  }, [props.userAns]);

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.userAns?.ans?.length).fill(false);
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.userAns?.ans?.length).fill(false);
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <>
      <Box sx={{ px: 3, color: "black" }}>
        {props.userAns &&
          props.userAns.ans.map((val, index) => {
            return (
              <Box sx={{borderRadius: 10, border: '1px solid #ccc', p: 2, my: 2}}>
                <span>Option {index + 1} : </span>
                <AudioButton
                  userAnswer={val}
                  playStatus={(status, end) => {
                    setPlayMode(status, index, end);
                  }}
                >
                  <IconButton
                    sx={{
                      color: "#DB8829",
                      backgroundColor: "#FFFFFF",
                      mx: 1,
                      padding: 0,
                    
                    }}
                  >
                    {currentIndexPlay[index] && (
                      <PauseIcon
                        sx={{
                          borderRadius: "50%",
                          padding: 1,
                          color: "#DB8829",
                          "@media (min-width: 1636px)": {
                            fontSize: "2.2rem",
                          },
                        }}
                      />
                    )}
                    {!currentIndexPlay[index] && (
                      <MusicNoteIcon
                        sx={{
                          borderRadius: "50%",
                          padding: 1,
                          "@media (min-width: 1636px)": {
                            fontSize: "2.2rem",
                          },
                        }}
                      />
                    )}
                  </IconButton>
                </AudioButton>
                {props.userAns.advResult[index] && (
                  <Grid container style={{ color: "#DB8829" }}>
                    <Grid xs={12}>
                      {props.userAns.advResult[index].length > 0 &&
                        props.userAns.advResult[index].map((val2, index) => {
                          return (
                            <Grid container mt={1}>
                              <Grid xs={3}>
                                <Typography variant="h6" fontWeight={"bold"}>
                                  {val2.word}
                                </Typography>
                              </Grid>
                              <Grid
                                xs={9}
                                sx={{
                                  borderLeft: "solid",
                                  borderLeftWidth: 3,
                                  borderLeftColor: "#DB8829",
                                  px: 2,
                                }}
                              >
                                {val2.result.map((val1, index1) => {
                                  return (
                                    <Grid container>
                                      <Grid xs={12}>{val1.type}</Grid>
                                      <Grid xs={5}>
                                        Expected: {val1.expected}
                                      </Grid>
                                      <Grid xs={5}>
                                        Accuracy:{" "}
                                        {val1.result
                                          ? "Accurate"
                                          : "Not Accurate"}
                                      </Grid>
                                      <Grid xs={2}>
                                        <StatusIndicator
                                          correct={val1.result}
                                        ></StatusIndicator>
                                      </Grid>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </Grid>
                          );
                        })}
                    </Grid>
                  </Grid>
                )}
              </Box>
            );
          })}
      </Box>
    </>
  );
};

export default RecadvAsset;
